import { Icon } from "@chakra-ui/react";
import { MdErrorOutline } from "react-icons/md";
import FilterButton from "components/Button/FilterButton";
import FilterChipMenu from "components/Button/FilterChipMenu";
import FilterSortSearchBar from "components/ControlBar/FilterSortSearchBar";
import { ACTION_TYPE_FILTER_OPTIONS, STATUS_FILTER_OPTIONS } from "features/Resources/Shared/constants";

interface ScheduleListFiltersProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  needsAttention: boolean;
  onNeedsAttentionChange: (value: boolean) => void;
  needsAttentionCount: number;
  statusFilter: string | undefined;
  onStatusChange: (value: string | undefined) => void;
  typeFilter: string | undefined;
  onTypeChange: (value: string | undefined) => void;
  onReset: () => void;
}

export default function ScheduleListFilters({
  searchText,
  onSearchChange,
  needsAttention,
  onNeedsAttentionChange,
  needsAttentionCount,
  statusFilter,
  onStatusChange,
  typeFilter,
  onTypeChange,
  onReset,
}: ScheduleListFiltersProps) {
  const hasActiveFilters = needsAttention || !!statusFilter || !!typeFilter || !!searchText;
  const needsAttentionLabel = needsAttentionCount > 0 ? `Needs attention (${needsAttentionCount})` : "Needs attention";

  return (
    <FilterSortSearchBar
      searchPlaceholder="Search actions..."
      searchValue={searchText}
      onSearchChange={onSearchChange}
      hideSort
      currentSort=""
      defaultSort=""
      onSortChange={() => {}}
      sortOptions={[]}
      quickFilters={
        <>
          <FilterButton
            onClick={() => onNeedsAttentionChange(!needsAttention)}
            isActive={needsAttention}
            icon={<Icon as={MdErrorOutline} color="statusRed.text" boxSize={4} />}
            size="sm"
          >
            {needsAttentionLabel}
          </FilterButton>
          <FilterChipMenu label="Status" options={STATUS_FILTER_OPTIONS} value={statusFilter} onChange={onStatusChange} />
          <FilterChipMenu label="Type" options={ACTION_TYPE_FILTER_OPTIONS} value={typeFilter} onChange={onTypeChange} />
        </>
      }
      activeFilters={[]}
      onReset={onReset}
      hasActiveFilters={hasActiveFilters}
    />
  );
}
